<button class="agenx-circle-button" [ngClass]="currentClasses" [title]="buttonCircleTitle">
  <img class="agenx-circle-button__img" [src]="buttonCircleSrc" alt="">
</button>